import { MediaType } from "../api/mediaApi";

export const addLeadingZero = (value : number, size : number) => {
    var valueString = value.toString();
    while (valueString.length < size) valueString = "0" + valueString;
    return valueString;
}

export const formatDuration = (durationMs : number) => {
    var ms = durationMs % 1000;
    var totalSeconds = Math.floor(durationMs / 1000);
    var seconds = totalSeconds % 60;
    var minutes = Math.floor(totalSeconds / 60);

    return `${addLeadingZero(minutes, 2)}:${addLeadingZero(seconds, 2)}:${addLeadingZero(ms, 3)}`
}

export const formatDurationShort = (durationMs : number) => {
    var ms = durationMs % 1000;
    var totalSeconds = Math.floor(durationMs / 1000);
    var seconds = totalSeconds % 60;
    var minutes = Math.floor(totalSeconds / 60);

    return `${addLeadingZero(minutes, 2)}:${addLeadingZero(seconds, 2)}`
}

export const formatToPercent = (num: number, lengthAfterDot: number = 1) => {
    let percent = (num*100).toFixed(lengthAfterDot);
    if (percent.indexOf('.') !== -1) {
        percent = percent.replace(/0+$/, '');
        percent = percent.replace(/\.$/, '');
    }
    return `${percent}%`
}

export const formatDurationLong = (durationMs : number) => {
    var totalSeconds = Math.floor(durationMs / 1000);
    var seconds = totalSeconds % 60;
    var totalMinutes = Math.floor(totalSeconds / 60);
    var minutes = totalMinutes % 60;
    var hours  = Math.floor(totalMinutes / 60);    
    
    return `${addLeadingZero(hours, 2)}:${addLeadingZero(minutes, 2)}:${addLeadingZero(seconds, 2)}`
}

export const converFromBytes = (bytes : number, to: 'KB' | 'MB' | 'GB') => {
    switch (to){
        case 'KB' : return bytes/1024.0;
        case 'MB' : return bytes/1024.0/1024.0;
        case 'GB' : return bytes/1024.0/1024.0/1024.0;
    }
}

export const renderMediaType = (mediaType: MediaType) => {
    switch(mediaType){
        case MediaType.Image : return `Image`;
        case MediaType.Video : return `Video`;
        case MediaType.VastUrl : return "VAST Url";
        case MediaType.Youtube : return "Youtube";
        case MediaType.YoutubeLive : return "Youtube Live";
        case MediaType.HiveStack : return "Hivestack";
    }
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export const getYoutubeImageUrlById = (url:string) => {
    if (url === "" || url === null) {
        return `https://img.youtube.com/vi/sddefault.jpg`
    }

    const urlObject = new URL(url);
    let urlOrigin = urlObject.origin;
    let urlPath = urlObject.pathname;

    if (urlOrigin.search('youtu.be') > -1) {
        return urlPath.substring(1);
    }

    if (urlPath.search('embed') > -1) {
        return urlPath.substring(7);
    }

    let previewYoutubeImageUrl = `https://img.youtube.com/vi/${urlObject.searchParams.get('v')}/sddefault.jpg`;
   
    return previewYoutubeImageUrl;
}

export const sortByNameString = (a:string, b:string) => a.toLowerCase() < b.toLowerCase() ? -1 : 1
export const sortByNumber = (a:number, b:number) => a < b ? -1 : 1
